import React from "react";

import "./RecognizedBy.css";

const CDN = "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english";

const RECOGNIZED_LOGOS = [
  { src: `${CDN}/nsdc-logo.png`, alt: "National Skill Development Corporation" },
  { src: `${CDN}/ministry-of-commerce-industry-logo.png`, alt: "Ministry of Commerce and Industry, Government of India" },
  { src: `${CDN}/startupindia-logo.png`, alt: "Startup India" },
  { src: `${CDN}/nasscom-logo.png`, alt: "NASSCOM" },
];

export default function RecognizedBy() {
  return (
    <section className="section-2807">
      <div className="div-block-1831980521448927">
        <div className="text-block-941288240601">Recognized by</div>
        <div className="div-block-1831980521448928">
          {RECOGNIZED_LOGOS.map((logo) => (
            <img key={logo.src} loading="lazy" src={logo.src} alt={logo.alt} className="recognized-by-logo" />
          ))}
        </div>
      </div>
    </section>
  );
}
